<transition name="slide-fade">
  <div class="ui-flash-msg" v-if="isOpen">
    <div class="msg-block">
      <p class="text">{{text}}</p>
    </div>
  </div>
</transition>